// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__k1o12","logoImage":"styles_logoImage__4UWDS","logoImageFull":"styles_logoImageFull__z6JKL"};